import { filter, find, get } from 'lodash';
import { useContext } from 'react';
import { FooterMenuContext } from '../components/context/footer-menu-context';
import { useMenus } from './use-menus';
import { useSite } from './use-site';
export var useFooterSecondaryMenu = function useFooterSecondaryMenu() {
  var site = useSite();
  var allMenus = useMenus() || [];
  var context = useContext(FooterMenuContext);
  var menuSlug = get(site, 'footerSecondaryMenu.slug', process.env.FOOTER_SECONDARY_MENU_SLUG || '');

  if (!menuSlug) {
    if (site.termsPage || site.privacyPolicyPage) {
      return {
        id: 'site-footer-secondary-menu-auto',
        items: filter([site.termsPage && {
          id: 'site-footer-secondary-menu-auto-terms-item',
          page: site.termsPage
        }, site.privacyPolicyPage && {
          id: 'site-footer-secondary-menu-auto-privacy-item',
          page: site.privacyPolicyPage
        }])
      };
    }
  }

  var menu = find(allMenus, function (menu) {
    return menu.slug === menuSlug;
  }); // legacy fallback

  return context || menu;
};